<template>
    <div class="selectCourt">
        <MyTitle theTitle="请选择法院"/>
            <div class="fd-select-court">
                <span>选择法院：</span>
                <p class="check-fy">{{info.checkedFy}}</p>
            </div>
            <!-- disabled -->
            <van-tabs class="fd-com-scroll" v-model="active">
                <van-tab title="高院">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.gjfyList" :key="index">
                            <span @click="gjfyListFun(item,$event)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="中级人民法院" :disabled="!info.zjfyList.length">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.zjfyList" :key="index">
                            <span @click="zjfyListFun(item,$event)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="基层法院" :disabled="!info.sjfyList.length">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.sjfyList" :key="index">
                            <span @click="sjfyListFun(item,$event)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>

            <div class="fd-com-btn-container">
                <van-button
                    type="info"
                    round
                    @click="sureBth">
                    确定
                </van-button>
            </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'
    import {Notify} from 'vant'
    import {getQueryPermission} from '../../api/common'
    export default {
        data() {
            return {
                info: {
                    checkedFy: "",
                    checkedFyId: "",
                    cId: "",
                    gjfyList: [],
                    zjfyList: [],
                    sjfyList: [],
                },
                active: 0,
                powerKeys_cBqlb: '',
                powerKeys_cBqlx: '',
                powerKeys_cFysx: '',

                permission_bq:''
            }
        },
        components: {
            MyTitle,
        },
        created() {
            this.creatData();
        },
        methods: {
            setPowerKeys(courtName){
                // debugger
                this.info.cId = courtName.id;
                this.info.checkedFy = courtName.name

                // this.powerKeys_cBqlx = courtName.cBqlx || ''
                // this.powerKeys_cBqlb = courtName.cBqlb || ''

                this.powerKeys_cFysx = courtName.cFysx || ''
            },
            creatData() {
                return new Promise((resolve, reject) => {
                    this.$axios.get('ssbq/api/xcx/fy?mklx=1&fyid=0').then(res => {
                        this.info.gjfyList = res.data
                        resolve()
                    })
                })
            },
            /**
             * 高级法院列表点击事件
             */
            gjfyListFun(courtName) {
                if(courtName.nSfkt !== 1){
                    Notify(`${courtName.name}暂未开通申请`)
                    return
                }

                this.setPowerKeys(courtName)
                this.$axios.get('ssbq/api/xcx/fy' + "?mklx=1&fyid=" + this.info.cId).then(res => {
                    this.info.zjfyList = res.data
                    this.info.sjfyList = []
                })
            },
            /**
             * 中级法院列表点击事件
             */
            zjfyListFun(courtName) {
                if(courtName.nSfkt !== 1){
                    Notify(`${courtName.name}暂未开通申请`)
                    return
                }
                this.setPowerKeys(courtName)
                this.$axios.get('ssbq/api/xcx/fy' + "?mklx=1&fyid=" + this.info.cId).then(res => {
                    this.info.sjfyList = res.data
                })

            },
            /**
             * 三级法院列表点击事件
             */
            sjfyListFun(courtName) {
                if(courtName.nSfkt !== 1){
                    Notify(`${courtName.name}暂未开通申请`)
                    return
                }
                this.setPowerKeys(courtName)
            },
            //点击确定按钮
            sureBth() {
                if (!this.info.cId) {
                }
                // 查询权限
                getQueryPermission({ptlx:2,mklx:1,fyid: this.info.cId}).then((res) => {
                    const {bqlx,bqlxAndbqlb,bqlbAndbqlx}=res.data;
                    this.permission_bq = {
                        lxtolb:bqlxAndbqlb,
                        lbtolx:bqlbAndbqlx
                    }
                    sessionStorage.setItem('xxcheckedFy', this.info.checkedFy);
                    sessionStorage.setItem('xxfcheckedFyKey', this.info.cId);
                    this.$router.push({
                        path: "/continuationPreservationNew",
                        query:{
                            bqid: this.$route.query.bqid,
                            sqbh: this.$route.query.sqbh,
                            cId: this.$route.query.cId,
                        }
                    });
                })
                .catch(() => {
                    this.$router.push({
                        path: "/continuationPreservationNew",
                        query:{
                            bqid: this.$route.query.bqid,
                            sqbh: this.$route.query.sqbh,
                            cId: this.$route.query.cId,
                        }
                    });
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    .selectCourt {
        width: 100%;
        height: 100%;
        background-color: #fff;
    }

    .fd-select-court {
        box-sizing: border-box;
        padding: 0 10px;
        line-height: 50px;
        display: flex;
    }

    .fd-xzfy-top {
        display: flex;
        box-sizing: border-box;
        padding: 0 20px;
        justify-content: space-between;

        > button {
            background: #fff;
            cursor: pointer;
        }
    }

    .fd-court-list {
        width: 100%;
        height: 71%;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 10px;

        > li {
            width: 100%;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
            border-bottom: 1px solid #eaeaea;
        }
    }

    .check-fy {
        color: red;
        width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .van-tabs {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .van-tabs__content {
        flex: 1;
        overflow-y: scroll;
    }
</style>
